import { useEffect, useState } from 'react';
import { ConfigProvider, theme } from 'antd';
import ruRU from 'antd/locale/ru_RU';
import { agentBrokerTheme } from '@shared/antd-theme';
import { BuildInfo } from '@shared/BuildInfo';
import { InvitesPage } from './InvitesPage';
import type { InvitesProps } from './types';

/** Тема острова следует за переключателем layout_app (data-theme на <html>): при dark
 *  добавляем darkAlgorithm, чтобы antd-таблица «Мои приглашённые» тоже темнела. */
function useDark(): boolean {
    const read = () => document.documentElement.getAttribute('data-theme') === 'dark';
    const [dark, setDark] = useState(read);
    useEffect(() => {
        const obs = new MutationObserver(() => setDark(read()));
        obs.observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'] });
        return () => obs.disconnect();
    }, []);
    return dark;
}

export function App(props: InvitesProps) {
    const dark = useDark();
    return (
        <ConfigProvider
            locale={ruRU}
            theme={{ ...agentBrokerTheme, algorithm: dark ? theme.darkAlgorithm : theme.defaultAlgorithm }}
        >
            <InvitesPage {...props} />
            <BuildInfo />
        </ConfigProvider>
    );
}
